import { QueryClient } from '@tanstack/react-query';

export class ReactQueryClientService {
  /* private constructor to prevent instantiation */
  private constructor() {}

  static readonly offlineQueryClient = new QueryClient({
    defaultOptions: {
      queries: {
        networkMode: 'always',
        retry: false,

        staleTime: Infinity,

        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
      },

      mutations: {
        networkMode: 'always',
        retry: false,
      },
    },
  });
}
